import { Modal, ModalOverlay, ModalContent, Image, CloseButton, Button, Box, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useContext, useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import MerchantContext from '../contexts/MerchantContext';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';
import palommaPlusBondaPopup from '../assets/palomma-plus-popup-bonda.png';
import palommaPlusAcrecerPopup from '../assets/palomma-plus-popup-acrecer.png';

const LOCAL_STORAGE_KEY = 'palommaPlusPopup';

const MERCHANT_POPUP_IMAGES: Record<string, string> = {
  acrecer: palommaPlusAcrecerPopup,
};

const PalommaPlusPopup = (): JSX.Element | null => {
  const { showSubscriptionOffer, selectSubscription, offer } = useContext(SubscriptionsContext);
  const { merchant } = useContext(MerchantContext);
  const formatCurrency = useCurrencyFormatter();
  const [dateDisplayed, setDateDisplayed] = useLocalStorage<string | null>(LOCAL_STORAGE_KEY, null);

  const popupImage = (merchant?.id && MERCHANT_POPUP_IMAGES[merchant.id]) || palommaPlusBondaPopup;

  const shouldDisplay = useMemo(() => {
    if (!showSubscriptionOffer) return false;
    return dateDisplayed !== dayjs().format('YYYY-MM-DD');
  }, [showSubscriptionOffer, dateDisplayed]);

  const handleClose = () => {
    setDateDisplayed(dayjs().format('YYYY-MM-DD'));
  };

  const handleObtenerBeneficio = () => {
    selectSubscription(true);
    handleClose();
  };

  if (!showSubscriptionOffer || !offer) return null;

  return (
    <Modal isOpen={shouldDisplay} onClose={handleClose} size="l" isCentered>
      <ModalOverlay />
      <ModalContent position="relative" boxShadow="none" maxW="fit-content" overflow="hidden" p={0}>
        <Box position="relative">
          <Image
            src={popupImage}
            alt="Palomma Plus"
            maxHeight="70vh"
            height="auto"
            width="auto"
            maxWidth="70vw"
            display="block"
          />
          <CloseButton
            position="absolute"
            right={2}
            top={2}
            zIndex={1}
            color="purple.500"
            _hover={{ color: 'purple.400' }}
            _focus={{ boxShadow: 'none' }}
            onClick={handleClose}
            size="sm"
          />
        </Box>
        <Box bg="white" p={4} display="flex" flexDirection="column" alignItems="center">
          <Button
            bg="rentals.primary.txt"
            color="white"
            _hover={{ bg: 'rentals.primary.btn' }}
            onClick={handleObtenerBeneficio}
            width="auto"
            minW="200px"
            px={8}
            py={3}
            fontWeight={700}
            textTransform="uppercase"
            borderRadius="md"
          >
            <VStack spacing={0} alignItems="center">
              <Text fontWeight={700} fontSize="1rem" color="white">
                Obtener Beneficio
              </Text>
              <Text fontSize="0.65rem" color="white" fontWeight={400} textTransform="lowercase">
                Por tan solo {formatCurrency(offer.price)}
              </Text>
            </VStack>
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PalommaPlusPopup;
